export const SET_CONTACT_FORM_FIELD_VALUE = 'SET_CONTACT_FORM_FIELD_VALUE'
export const SUBMIT_CONTACT_MESSAGE = 'SUBMIT_CONTACT_MESSAGE'
export const UPDATE_CONTACT_CURRENT_FORM_STEP = 'UPDATE_CONTACT_CURRENT_FORM_STEP'
export const RESET_CONTACT_FORM_VALUES = 'RESET_CONTACT_FORM_VALUES'
export const CONTACT_US_RESPONSE = 'CONTACT_US_RESPONSE'
